import {
  NOTIFICATION_SHOW,
  NOTIFICATION_CLOSE,
  SNACKBAR_SHOW,
  SNACKBAR_CLOSE,
  UPDATED_USER_REQUEST_ERROR,
  UPDATE_USER,
} from '../constants/actions';
import { formatError } from '../constants/endpoints';
import i18n from '@app/i18n';

export const initialState = {
  notification: null,
  snackBar: null,
  linkID: null,
};

const notification = (state = initialState, action) => {
  switch (action.type) {
    // add addition actions to show snackbar here using this template
    case UPDATED_USER_REQUEST_ERROR: {
      return {
        ...state,
        snackBar: { text: action.payload, isError: true },
        linkID: null,
      };
    }
    case formatError(UPDATE_USER): {
      const error = action?.payload?.error?.error;
      const conflictMessage = error?.name === 'ConflictError' && error?.message;
      return {
        ...state,
        snackBar: {
          text: conflictMessage || i18n.t('teamManagement:users.updateFailed'),
          isError: true,
        },
        linkID: null,
      };
    }
    case 'SNACKBAR_CLICKED': {
      return { ...state, linkID: action.payload };
    }
    case SNACKBAR_SHOW: {
      return { ...state, snackBar: action.payload, linkID: null };
    }
    case SNACKBAR_CLOSE: {
      return { ...state, snackBar: null };
    }
    case NOTIFICATION_SHOW: {
      return { notification: { ...action.payload, show: true } };
    }
    case NOTIFICATION_CLOSE: {
      return initialState;
    }
    default:
      return state;
  }
};

export default notification;
